export const getFirstDayOfWeek = (locale: string) => {
  // array of locales that Sunday is the first day of the week
  const sundayLocales = ['en_US', 'es_US', 'pt_BR', 'pt'];

  return sundayLocales.indexOf(locale) !== -1 ? 0 : 1;
};
